const siteConfig = {
  brandName: "hibleora",
  wordmark: "hibleora",
  description:
    "Material-led homeware, small comforts and useful objects for considered everyday spaces.",
  announcement: "Hong Kong storefront · Secure hosted checkout · Customer care by email",
  operatingRegion: "Hong Kong",
  countryCode: "HK",
  language: "en",
  languageLabel: "English",
  currency: "USD",
  currencyName: "US dollars",
  currencySymbol: "US$",
  locale: "en-HK",
  timezone: "Asia/Hong_Kong",
  shippingFee: 9.99,
  contact: {
    email: "restore@hibleora.shop",
    location: ["Hong Kong SAR"],
    locationStatus:
      "Online storefront and fulfilment origin. An authorised Hong Kong return address is provided in writing after a return is approved.",
  },
  fulfilment: {
    origin: "Hong Kong fulfilment centre",
    dispatchTime: "1–3 business days after payment and stock confirmation",
    carriers: {
      domestic: "SF Express",
      regional: "SF Express or Hongkong Post tracked service",
      international: "DHL eCommerce or Hongkong Post tracked service",
    },
    deliveryEstimates: {
      domestic: "1–2 business days after dispatch",
      regional: "3–7 business days after dispatch",
      international: "7–14 business days after dispatch",
    },
    totalEstimates: {
      domestic: "2–5 business days",
      regional: "4–10 business days",
      international: "8–17 business days",
    },
    regionalDestinations: ["Macao", "Taiwan", "Japan", "Singapore", "South Korea"],
    trackingNotice:
      "A dispatch email with the carrier name and tracking number is sent when the parcel leaves the fulfilment centre.",
  },
  payment: {
    endpoint: "/create_payment.php",
    supportedDisplayMethods: ["Hosted card checkout"],
  },
  checkoutCountries: [
    "Australia",
    "Canada",
    "France",
    "Germany",
    "Hong Kong",
    "Japan",
    "Macao",
    "New Zealand",
    "Singapore",
    "South Korea",
    "Taiwan",
    "United Kingdom",
    "United States",
  ],
};

export const formatMoney = (amount) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    minimumFractionDigits: 2,
  }).format(amount);

export default siteConfig;
